module.exports = __webpack_public_path__ + "static/media/Format-for-giving-comments.11bbf8ce.docx";